import { DefaultError, useMutation } from '@tanstack/react-query';
import { useQueryToast } from 'hooks';
import i18next from 'i18next';
import { apiClient } from 'utils';
import { useResponseHandler } from 'utils/service/responseHandler';
import { handleErrorsResponse } from 'utils/service/errorHandler';
import { ICodeOtpQR, IConfirmTwoFactorOTP } from './types';

export const useCodeOtpQR = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success } = useQueryToast('useCodeOtpQR');
  
  return useMutation<any, DefaultError, ICodeOtpQR>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.codeOtpQR.loading'));
      const response = await apiClient({
        method: 'POST',
        url: 'Auth/CodeOtpQR',
        body,
      });

      return responseHandler(response, { groupName: 'useCodeOtpQR' });
    },
    onError: dismiss,
    onSuccess: () => {
      success(i18next.t('service-message.auth.codeOtpQR.success'));
    },
  });
};

export const useConfirmTwoFactorOTP = () => {
  const { responseHandler } = useResponseHandler();
  const { loading, dismiss, success, failure } = useQueryToast('useConfirmTwoFactorOTP');
  
  return useMutation<any, DefaultError, IConfirmTwoFactorOTP>({
    async mutationFn(body) {
      loading(i18next.t('service-message.auth.confirmTwoFactorOTP.loading'));
      const response = await apiClient({
        method: 'POST',
        url: 'Auth/ConfirmTwoFactorOTP',
        body,
      });

      return responseHandler(response, { groupName: 'useConfirmTwoFactorOTP' });
    },
    onError: (error: DefaultError) => {
      dismiss();
      try {
        const { toasts } = handleErrorsResponse(error.message);
        if (toasts.length) {
          toasts.forEach(message => failure(message));
        } else {
          failure(i18next.t('service-message.auth.confirmTwoFactorOTP.failure'));
        }
      } catch {
        failure(i18next.t('service-message.auth.confirmTwoFactorOTP.failure'));
      }
    },
    onSuccess: () => {
      success(i18next.t('service-message.auth.confirmTwoFactorOTP.success'));
    },
  });
};
